import React, { useEffect, useState, useMemo } from 'react';
import { Chart } from 'primereact/chart';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Card } from "primereact/card";
import { RetraitService } from '../service/RetraitService';



const TableauDeBord = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const retraitService = new RetraitService()

  let codeIesr = localStorage.getItem("codeIesr")
  let role_admin = localStorage.getItem("admin_secure")
  let role_univ = localStorage.getItem("univ_secure")
  role_admin = JSON.parse(role_admin)
  role_univ = JSON.parse(role_univ)
  codeIesr = JSON.parse(codeIesr)

  useEffect(() => {
    if(role_univ){
      const loadStats = async () => {
      try {
        const data = await retraitService.getNbInscrisUniv(codeIesr);
        console.log(data)
        setStats(data);
      } catch (err) {
        console.error(err);
        setError("Erreur lors du chargement des statistiques.");
      } finally {
        setLoading(false);
      }
    };

    loadStats();
    }
    else if(role_admin){
      const loadStats = async () => {
      try {
        const data = await retraitService.getNbInscris();
        console.log(data)
        setStats(data);
      } catch (err) {
        console.error(err);
        setError("Erreur lors du chargement des statistiques.");
      } finally {
        setLoading(false);
      }
    };

    loadStats();
    }
    
  }, []);

  // Données pour le diagramme en secteurs (Pie)
  const pieData = useMemo(() => {
    if (!stats) return {};

    return {
      labels: ['Total inscrits', 'Total diplômés', 'Diplômes retirés'],
      datasets: [
        {
          data: [
            stats.nbTotalInscrit,
            stats.nbTotaleDiplome,
            stats.nbDiplomeRetire,
          ],
          backgroundColor: ['#42A5F5', '#66BB6A', '#FFA726'],
          hoverBackgroundColor: ['#64B5F6', '#81C784', '#FFB74D'],
        },
      ],
    };
  }, [stats]);

  const pieOptions = {
    plugins: {
      legend: {
        position: 'bottom',
      },
    },
  };

  // Données pour le diagramme en ligne
  // Ici on fait 3 courbes (une par variable) avec comme axe X l’année (une seule valeur).
  const lineData = useMemo(() => {
    if (!stats) return {};

    const labels = [stats.libelleAnnee || 'Année'];

    return {
      labels,
      datasets: [
        {
          label: 'Total inscrits',
          data: [stats.nbTotalInscrit],
          fill: false,
          tension: 0.4,
          borderColor: '#42A5F5',
          pointBackgroundColor: '#42A5F5',
        },
        {
          label: 'Total diplômés',
          data: [stats.nbTotaleDiplome],
          fill: false,
          tension: 0.4,
          borderColor: '#66BB6A',
          pointBackgroundColor: '#66BB6A',
        },
        {
          label: 'Diplômes retirés',
          data: [stats.nbDiplomeRetire],
          fill: false,
          tension: 0.4,
          borderColor: '#FFA726',
          pointBackgroundColor: '#FFA726',
        },
      ],
    };
  }, [stats]);

  const lineOptions = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          precision: 0, // pour ne pas avoir de décimales si ce sont des entiers
        },
      },
    },
  };

  if (loading) {
    return <div>Chargement des statistiques...</div>;
  }

  if (error) {
    return <div style={{ color: 'red' }}>{error}</div>;
  }

  if (!stats) {
    return <div>Aucune donnée trouvée.</div>;
  }

  return (
    <Card style={{ padding: '1.5rem' }}>
      <h2 style={{ marginBottom: '0.5rem' }}>Tableau de bord des retraits de diplômes</h2>
      <p style={{ marginBottom: '1.5rem' }}>
        {stats.nomUniversite} — Année académique {stats.libelleAnnee}
      </p>

      {/* Zone des graphiques */}
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '1.5rem',
          marginBottom: '2rem',
        }}
      >
        <div style={{ flex: '1 1 300px', minWidth: '280px' }}>
          <h3>Répartition des statistiques</h3>
          <Chart type="pie" data={pieData} options={pieOptions} />
        </div>

        <div style={{ flex: '1 1 300px', minWidth: '280px', height: '300px' }}>
          <h3>Évolution (par année)</h3>
          <Chart type="line" data={lineData} options={lineOptions} />
        </div>
      </div>

      {/* DataTable des stats */}
      <h3>Détails par université</h3>
      <DataTable
        value={[stats]} // tableau avec un seul élément
        stripedRows
        showGridlines
        style={{ marginTop: '0.5rem' }}
      >
        <Column
          field="nomUniversite"
          header="Université"
          style={{ minWidth: '250px' }}
        />
        <Column
          field="nbTotalInscrit"
          header="Total inscrits"
          style={{ minWidth: '150px' }}
        />
        <Column
          field="nbTotaleDiplome"
          header="Total diplômés"
          style={{ minWidth: '150px' }}
        />
        <Column
          field="nbDiplomeRetire"
          header="Diplômes retirés"
          style={{ minWidth: '150px' }}
        />
      </DataTable>
    </Card>
  );
};

export default TableauDeBord;